/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table, Input, Modal, Space, Button, Popconfirm, Row,
  Col,
} from 'antd';
import 'jspdf-autotable';
import moment from 'moment';
import ReactJson from 'react-json-view';
import {
  getQueueMessages, requeueQueueMessageById, deleteQueueMessageById,
} from '../../redux/actions/QueueMessage';
import PageLimitSwitch from '../../components/PageLimitSwitch';

import generateQuery, { handleSearch as search } from '../../util/table';
import QueueMessageDetailsForModal from './QueueMessageDetailsForModal';

const columns = (onRequeueMessage, onDeleteMessage) => [
  {
    title: 'Created',
    dataIndex: 'created_at',
    render: (date) => (
      <span>{moment(date).format('DD/MM/YY h:mm:ss a')}</span>
    ),
    sorter: true,
    search: false,
  },
  {
    title: 'Queue Name',
    dataIndex: 'queue_name',
    sorter: true,
  },
  {
    title: 'Attempts',
    dataIndex: 'attempts',
    sorter: true,
  },
  {
    title: 'Message',
    dataIndex: 'message',
    render: (message) => (
      <ReactJson src={message} />
    ),
  },
  {
    title: 'Error Response',
    dataIndex: 'error_response',
    render: (error_response) => (
      <ReactJson src={error_response} />
    ),
  },
  {
    title: '',
    key: 'action',
    search: false,
    render: (record) => {
      const { _id } = record;
      return (
        <Space size="middle">
          <Popconfirm title={`Sure to requeue? ${_id}`} onConfirm={() => onRequeueMessage(_id)}>
            <Button
              primary
              className="ant-btn-sm"
            >
              Requeue
            </Button>
          </Popconfirm>
          <Popconfirm title={`Sure to delete? ${_id}`} onConfirm={() => onDeleteMessage(_id)}>
            <Button
              danger
              className="ant-btn-sm"
            >
              Delete
            </Button>
          </Popconfirm>
        </Space>
      );
    },
  },
];

const QueueMessage = () => {
  const dispatch = useDispatch();
  const {
    data, pageSize, currentPage, totalRecords, loading,
  } = useSelector(({ queue_message }) => queue_message.queue_messages);
  // const {
  //   data, pageSize, currentPage, totalRecords, loading,
  // } = useSelector(({ event_log }) => event_log.event_logs);
  const [searchParams, setSearchParams] = useState('');

  useEffect(() => {
    const pagination = `page=${currentPage}&limit=${pageSize}`;
    dispatch(getQueueMessages(pagination));
  }, [dispatch, currentPage, pageSize]);

  const [visibleQueueMessageModal, setVisibilityQueueMessageModal] = useState(false);
  const [selectedQueueMessageId, setSelectedQueueMessageId] = useState(false);

  const dataSource = data.length && data.length
  && data.map(({
    _id,
    queue_name,
    action,
    created_at,
    attempts,
    message,
    error_response,
  }) => ({
    key: _id,
    _id,
    queue_name,
    action,
    created_at,
    attempts,
    message,
    error_response: error_response || {},
  }));

  // const navigateToView = (record) => ({
  //   onClick: () => {
  //     // setSelectedQueueMessageId(record.key);
  //     // setVisibilityQueueMessageModal(true);
  //   },
  // });

  const handleOnChange = (pagination, filters, sorter) => {
    dispatch(getQueueMessages(generateQuery(pagination, filters, sorter, searchParams)));
  };

  const handleSearch = (searchValue) => {
    const query = search(searchValue, dispatch, getQueueMessages, columns);
    setSearchParams(query);
  };

  const handleRequeueMessage = (id) => {
    dispatch(requeueQueueMessageById(id));
  };

  const handleDeleteMessage = (id) => {
    dispatch(deleteQueueMessageById(id));
  };

  const props = {
    pagination: false,
    onChange: handleOnChange,
    loading,
    columns: columns(handleRequeueMessage, handleDeleteMessage),
    dataSource,
  };

  const handleModalCancelQueueMessageModal = () => {
    setVisibilityQueueMessageModal(false);
    setSelectedQueueMessageId('');
  };

  return (
    <div>
      <h2 className="title gx-mb-4">Queue Messages</h2>
      <div className="gx-d-flex justify-content-center">
        <Input.Search
          placeholder="Search QueueMessages"
          enterButton
          allowClear
          onSearch={(value) => handleSearch(
            value,
            dispatch,
            getQueueMessages,
            columns,
            setSearchParams,
          )}
        />
      </div>
      <div className="justify-content-center">
        <Table className="gx-table-responsive striped-table" {...props} />
        <Row className="pagination">
          <Col md={12}>
            <PageLimitSwitch
              resourceType="queue_messages"
              limit={pageSize}
              limits={[10, 100, 200, 500, 1000, 2000, 5000, 10000]}
              totalRecords={totalRecords}
              currentPage={currentPage}
            />
          </Col>
        </Row>
      </div>
      <Modal
        visible={visibleQueueMessageModal}
        okText="Close"
        confirmLoading={(loading && loading)}
        onCancel={handleModalCancelQueueMessageModal}
        onOk={handleModalCancelQueueMessageModal}
        footer={`QueueMessage #${selectedQueueMessageId}`}
      >
        <QueueMessageDetailsForModal {...{ queueMessageId: selectedQueueMessageId }} />
      </Modal>
    </div>
  );
};

export default QueueMessage;
